import React from 'react';

import { Space, Typography } from '@sravni/react-design-system';
import pluralize from '@sravni/utils/lib/pluralize';

import { ReviewType } from '../../../../helpers/reviews';
import { useOrganizationsTotal } from '../../../../store/hooks/organizations';
import { useReviewsStats } from '../../../../store/hooks/reviews';

type TProps = {
  reviewTypes: ReviewType;
  isMobile?: boolean;
};

export const HeadingDescription: React.FC<TProps> = ({ reviewTypes, isMobile }) => {
  const organizationsTotal = useOrganizationsTotal();
  const reviewsStats = useReviewsStats();
  const { namesType } = reviewTypes;

  const list = [
    {
      value: reviewsStats?.reviewsCount,
      text: reviewsStats?.reviewsCount && pluralize(reviewsStats.reviewsCount, 'отзыв', 'отзыва', 'отзывов'),
    },
    {
      value: organizationsTotal,
      text:
        organizationsTotal &&
        `${pluralize(organizationsTotal, namesType.smallFirstChar, namesType.mode10, namesType.mode7)} по всей России`,
    },
    {
      value: reviewsStats?.solutionsCount,
      text:
        reviewsStats?.solutionsCount &&
        `${pluralize(reviewsStats.solutionsCount, 'проблема', 'проблемы', 'проблем')} решено на Сравни`,
    },
  ];

  if (!list?.length) return null;

  return (
    <Space className={isMobile ? 'h-mt-8 h-mb-12' : 'h-mt-8'} wrap>
      {list.map((item, i) => {
        if (!item.value) return null;
        return (
          <span key={item.value}>
            <Typography.Text as={'span'}>
              {String(item.value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} {item.text}
            </Typography.Text>
            {(isMobile ? i === 0 : i < list.length - 1) && <span className={'h-ml-8 h-mr-8'}>·</span>}
          </span>
        );
      })}
    </Space>
  );
};
